export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderList@2x.png";